import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import bannersModule, { BannerTypes } from '@gin-betting/banners';
import { createSelector } from 'reselect';

import type { State } from 'types';

interface Input {
    bannerId: string;
}

interface Output {
    banner: BannerTypes.BannerInfo | null;
}

const {
    selectors: { selectCmsBanners },
} = bannersModule;

const selectBannerId = (_: State, bannerId: string) => bannerId;

const makeSelector = () =>
    createSelector(
        selectCmsBanners,
        selectBannerId,
        (cmsBanners, bannerId) =>
            cmsBanners.find(banner => banner.id === bannerId) || null
    );

function useBanners({ bannerId }: Input): Output {
    const selectBanner = useMemo(() => makeSelector(), []);
    const banner = useSelector(state => selectBanner(state, bannerId));

    return {
        banner,
    };
}

export default useBanners;
